import {Component, HostListener} from '@angular/core';
import {UsanaObject} from "../../../usana-object";
import {LoggerService} from "../../../common/logger.service";

@Component({
    selector: 'celebrate',
    templateUrl: './celebrate.component.html',
    styleUrls: ['./celebrate.component.scss'],
    standalone: false
})
export class CelebrateComponent extends UsanaObject {
    show = false;
    text = 'RYANLYTICS 4.0!!';
    private timeoutId: any;

    constructor(loggerService: LoggerService) {
        super(loggerService);
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
        if (event.code === 'Space') {
            event.preventDefault();
            this.resetCelebration();
        }
    }

    private resetCelebration() {
        clearTimeout(this.timeoutId);
        this.show = false;
        // Force a new animation by waiting one frame
        requestAnimationFrame(() => {
            this.show = true;
            this.timeoutId = setTimeout(() => this.show = false, 7000);
        });
    }

    trackByFn(index: number): number {
        return index;
    }
}
